<template>
  <div class="download-progress" v-if="percent">
    <el-progress :percentage="mapPercent"></el-progress>
    <el-button type="danger" plain @click="cancelDownload">取消</el-button>
  </div>
</template>

<script>
export default {
  dat () {
    return {}
  },
  props: {
    percent: {
      type: Number,
      default: 0
    }
  },
  computed: {
    mapPercent () {
      return +(this.percent * 100).toFixed(1)
    }
  },
  methods: {
    cancelDownload () {
      this.$emit('cancel')
    }
  }
}
</script>

<style lang="scss">
.download-progress {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 10000;
  .el-progress {
    width: 60%;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  .el-progress__text {
    color: #fff;
  }
  .el-button--danger {
    position: absolute;
    bottom: 12%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}
</style>
